import React, { FunctionComponent } from 'react';
import { Layout, Typography } from 'antd';
import { useRouteError } from 'react-router-dom';
import styles from './styles.module.less';

const ErrorBoundary: FunctionComponent = () => {
  const { Title } = Typography;
  const error = useRouteError() as Error;

  return (
    <Layout>
      <div className={styles.siteLayout}>
        <div className={styles.container}>
          <div>
            <Title>An unexpected error has occurred</Title>
            <Title level={5}>{error.message || JSON.stringify(error)}</Title>
            <a href={window.location.href}>Reload</a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ErrorBoundary;
